import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User} from '../models/user';
import { ResourceService } from '../../../core/services/resource.service';
import { map, Observable, from, throwError } from 'rxjs';
import { shareReplay, take, filter, switchMap } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogConfig, ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { AlertDialog, AlertDialogConfig } from '../components/alert/dialog';

@Injectable({ providedIn: 'root' })
export class UserService extends ResourceService<User> {
  constructor( private readonly dialog_: MatDialog, private http: HttpClient,
    private configService: AppConfigService, ) {
    super(
      http,
      User,
      'users'
    );
  }

  public addUser(object: any): Observable<any> {
    console.log(' object to add', object)
    if(object.id){
      return from(this.api
        .put('route-api', `${this.apiUrl}/${object.id}`, {
          body: object
        })
        );
    }
    return  from(this.api
      .post('route-api', `users`, {
        body: object
      })
      );
  }



  public deleteResourceOfUser(object: any): Observable<any> {

    const config = {
      title: 'Confirmer',
      message: 'Souhaitez-vous confirmer la suppression de la ressource '+ object.name+ ' du usere '+object.user+' ?',
    } as ConfirmDialogConfig;

    return this.dialog_
    .open(ConfirmDialogComponent, {data: config})
    .afterClosed()
    .pipe(filter(result => result))
    .pipe(
      switchMap(_ => {

        return  from(this.api
          .del('route-api', `users/${object.user}/resources/${object.name}`, {

          })
          )
          })
          )

          ;
  }



  public deleteUserOfUser(object: any): Observable<any> {

    const config = {
      title: 'Confirmer',
      message: 'Souhaitez-vous confirmer la suppression de l\'utilisateur '+ object.email+ ' du usere '+object.user+' ?',
    } as ConfirmDialogConfig;

    return this.dialog_
    .open(ConfirmDialogComponent, {data: config})
    .afterClosed()
    .pipe(filter(result => result))
    .pipe(
      switchMap(_ => {

        return  from(this.api
          .del('route-api', `users/${object.user}/users/${object.email}`, {

          })
          )
          })
          )

          ;
  }

  public getUsersOf(id: string): Observable<any> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/${id}/users`, {}))
      .pipe<any>(map(result => result.resource));
  }

  public getResourcesOf(id: string): Observable<any> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/${id}/resources`, {}))
      .pipe<any>(map(result => result.resource));
  }


  public searchUser(query_term: string): Observable<any> {
    return from(this.api
      .get('route-api', `${this.apiUrl}`, {queryStringParameters: {q: query_term}}))
      .pipe<any>(map(result => result.resource));
  }

}


